import { render, staticRenderFns } from "./ClinicalTrials.vue?vue&type=template&id=740292a6&scoped=true&"
import script from "./ClinicalTrials.vue?vue&type=script&lang=ts&"
export * from "./ClinicalTrials.vue?vue&type=script&lang=ts&"
import style0 from "./ClinicalTrials.vue?vue&type=style&index=0&id=740292a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740292a6",
  null
  
)

export default component.exports